<script setup>
import { useI18n } from 'vue-i18n';
import PostSaleNotificationBell from './PostSaleNotificationBell.vue';

defineProps({
  loading: { type: Boolean, default: false },
});

const emit = defineEmits(['open-notification', 'refresh']);
const { t } = useI18n();
</script>

<template>
  <header
    data-testid="post-sale-index-header"
    class="flex h-16 min-w-0 items-center border-b border-lais-border-soft bg-white px-5 shadow-lais-soft"
  >
    <div class="min-w-0">
      <h1 class="truncate text-lg font-semibold text-lais-text">
        {{ t('POST_SALE.TITLE') }}
      </h1>
      <p class="truncate text-xs text-lais-text-muted">
        {{ t('POST_SALE.SUBTITLE') }}
      </p>
    </div>
    <div class="ml-auto flex items-center gap-3">
      <PostSaleNotificationBell @open="emit('open-notification', $event)" />
      <button
        type="button"
        class="inline-flex min-h-9 items-center gap-2 rounded-lais px-3 text-sm font-bold text-lais-text transition hover:bg-lais-bg-soft disabled:cursor-not-allowed disabled:opacity-50"
        :disabled="loading"
        :aria-busy="loading"
        @click="emit('refresh')"
      >
        <span
          class="size-4 text-[#01988C]"
          :class="
            loading
              ? 'i-lucide-loader-circle animate-spin'
              : 'i-lucide-refresh-cw'
          "
          aria-hidden="true"
        />
        {{ t('POST_SALE.ACTIONS.REFRESH') }}
      </button>
    </div>
  </header>
</template>
